<template>
  <div class="sectionKoko" style="text-align: left">
    <div class="container">
      <div class="row justify-content-between">
        <div class="col-lg-4 col-sm-12 mt-1">
          <img src="@/assets/images/logo1.png" alt=“logo-grey” height="70">
          <div class="row row-cols-auto mt-3">
            <div class="col">
              <a href="https://www.facebook.com/paykokoapp">
                <img src="@/assets/images/facebook.jpg" width="50" alt="facebook">
              </a>
            </div>
            <div class="col">
              <a href="https://www.instagram.com/paykokoapp/">
                <img src="@/assets/images/instagram.jpg" width="50" alt="instagram">
              </a>
            </div>
            <div class="col">
              <a href="https://twitter.com/paykokoapp">
                <img src="@/assets/images/twitter.jpg" width="50">
              </a>
            </div>
            <div class="col">
              <a href="https://www.youtube.com/channel/UCkjFKyiupLUsDI94_R1Xt_w">
                <img src="@/assets/images/youtube.jpg" width="50">
              </a>
            </div>
            <div class="col">
              <a href="https://www.tiktok.com/@paykokoapp">
                <img src="@/assets/images/tiktok.webp" width="50">
              </a>
            </div>
            <div class="col">
              <a href="https://www.linkedin.com/company/paykokoapp">
                <img src="@/assets/images/linkedin.jpg" width="50">
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-sm-12">

          <div class="row mt-1">
            <div class="col-sm-6 col-xs-12 mt-3">
              <div class="footerTextTitle">{{ $t("footer.header4") }}</div>
              <router-link to="/about"><div class="footerText">{{ $t("footer.header5") }}</div></router-link>
              <a href="https://www.linkedin.com/company/paykokoapp/jobs"><div class="footerText">{{ $t("footer.header6") }}</div></a>
              <router-link to="/press"><div class="footerText">{{ $t("footer.header7") }}</div></router-link>
              <a href="http://onelink.to/yhyq66"><div class="footerText">{{ $t("footer.header8") }}</div></a>

            </div>

            <div class="col-sm-6 col-xs-12 mt-3">
              <div class="footerTextTitle">{{ $t("footer.header9") }}</div>
              <router-link to="/business" class="footerText">{{ $t("footer.header10") }}</router-link>
              <a href="https://merchant-v2.paykoko.com/"><div class="footerText">{{ $t("footer.header11") }}</div></a>
            </div>
          </div>


        </div>
      </div>



    </div>


    <div class="container mt-4">
      <hr/>


      <div class="row">
        <div class="col-sm-8 col-xs-12 mt-2 lastLineText" >
          Copyright © 2021 Dinnovation (Pvt) Limited. All rights reserved.
        </div>
        <div class="col-sm-4 col-xs-12 mt-2 text-right" style="text-align: right">
          <div class="d-block d-sm-none" style="text-align: left">
            <router-link to="/privacy">
              <a class="lastLineText">{{ $t("footer.header1") }}</a>
            </router-link>
            |
            <router-link to="/terms">
              <a class="lastLineText">{{ $t("footer.header3") }}</a>
            </router-link>
          </div>

          <div class="d-none d-sm-block">
            <router-link to="/privacy">
              <a class="lastLineText">{{ $t("footer.header2") }}</a>
            </router-link>
            |
            <router-link to="/terms">
              <a class="lastLineText">{{ $t("footer.header3") }}</a>
            </router-link>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "FooterWeb"
}
</script>

<style scoped>

.sectionKoko {
  padding-top: 60px;
  padding-bottom: 60px;
  padding:5%;
}

.lastLineText {
  font-size: 12px;
  color: black;
}

.footerTextTitle {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-decoration: none;
}

.footerText {
  font-size: 14px;
  color: black;
}

.col {
  padding: 0;
}

.mobile-offcanvas {
  background-color: #F2EEE8;
}

a {
  padding: 0;
  text-decoration: none;
}
</style>

